import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AnalyticsService } from '../../../../shared/modules/analytics/services/analytics.service';
import { swiperDefaultConfig } from '@app/shared/directives/swiper.directive';

@Component({
  selector: 'evc-quote-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntroComponent implements OnInit {
  @Output() stepReady: EventEmitter<any> = new EventEmitter();
  slidesIterator = [1, 2, 3, 4, 5];

  swiperConfig = {
    ...swiperDefaultConfig,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: this.slidesIterator.length,
        spaceBetween: 40,
      },
    },
  };

  constructor(private analyticsService: AnalyticsService) {}

  navigate() {
    this.stepReady.emit();
  }

  ngOnInit(): void {
    this.analytics();
  }

  private analytics() {
    this.analyticsService.push({
      event: 'evcQuote-Step',
      page: {
        step: 'intro',
      },
    });
  }
}
